"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareDialog = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var ShareDialogBase_1 = require("./ShareDialogBase/ShareDialogBase");
var shareDialogMappers_1 = require("./shareDialogMappers");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var ComponentLabelsContext_1 = require("./ShareDialogBase/ComponentLabelsContext");
/**
 * @internal
 */
exports.ShareDialog = function (props) {
    var backend = props.backend, workspace = props.workspace, locale = props.locale, sharedObject = props.sharedObject, currentUserRef = props.currentUserRef, onApply = props.onApply, onCancel = props.onCancel, onError = props.onError, isLockingSupported = props.isLockingSupported, labels = props.labels;
    var effectiveBackend = sdk_ui_1.useBackendStrict(backend);
    var effectiveWorkspace = sdk_ui_1.useWorkspaceStrict(workspace);
    var onShareDialogBaseError = react_1.useCallback(function (err) {
        onError === null || onError === void 0 ? void 0 : onError(new sdk_ui_1.UnexpectedSdkError(err.message, err));
    }, [onError]);
    var owner = react_1.useMemo(function () {
        if (sharedObject.createdBy) {
            return shareDialogMappers_1.mapOwnerToGrantee(sharedObject.createdBy, currentUserRef);
        }
        return shareDialogMappers_1.mapUserToInactiveOwner();
    }, [sharedObject, currentUserRef]);
    var onSubmit = react_1.useCallback(function (grantees, granteesToAdd, granteesToDelete, isUnderLenientControl, isLocked) {
        var shareStatus = shareDialogMappers_1.mapGranteesToShareStatus(grantees, granteesToAdd, granteesToDelete);
        var isUnderStrictControl = shareStatus !== "public" && !isUnderLenientControl;
        var add = shareDialogMappers_1.mapGranteesToAccessGrantees(granteesToAdd);
        var del = shareDialogMappers_1.mapGranteesToAccessGrantees(granteesToDelete);
        onApply({
            shareStatus: shareStatus,
            isUnderStrictControl: isUnderStrictControl,
            isLocked: isLocked,
            granteesToAdd: add,
            granteesToDelete: del,
        });
    }, [onApply]);
    var affectedSharedObject = react_1.useMemo(function () {
        var isLeniencyControlSupported = !effectiveBackend.capabilities.usesStrictAccessControl;
        return shareDialogMappers_1.mapSharedObjectToAffectedSharedObject(sharedObject, owner, isLockingSupported, isLeniencyControlSupported);
    }, [sharedObject, owner, isLockingSupported, effectiveBackend]);
    return (react_1.default.createElement(sdk_ui_1.IntlWrapper, { locale: locale },
        react_1.default.createElement(sdk_ui_1.BackendProvider, { backend: effectiveBackend },
            react_1.default.createElement(sdk_ui_1.WorkspaceProvider, { workspace: effectiveWorkspace },
                react_1.default.createElement(ComponentLabelsContext_1.ComponentLabelsProvider, { labels: labels },
                    react_1.default.createElement(ShareDialogBase_1.ShareDialogBase, { currentUserRef: currentUserRef, sharedObject: affectedSharedObject, onCancel: onCancel, onSubmit: onSubmit, onError: onShareDialogBaseError }))))));
};
//# sourceMappingURL=ShareDialog.js.map